<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get("shared.visitorCards")}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get("shared.dashboard")}}</span>
        </li>
        <li>
          <i class="fa fa-address-card"></i>
          <span>{{$ml.get("shared.visitors")}}</span>
        </li>
        <li>
          <span>{{$ml.get("shared.visitorCards")}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-3">
          <div class="input-group" style="margin-bottom:7px;">
            <input
              type="text" @keyup.enter="getEmployeesFromCardNoFast(searchText)"
              :placeholder="$ml.get('visitorCards.searchVisitorCardInList')"
              v-model="searchText"
              class="form-control"
            />
            <span class="input-group-btn">
              <button type="button" class="btn btn-primary">
                <i class="fa fa-search"></i>
              </button>
            </span>
          </div>
          <div class="box box-primary">
            <div class="box-header with-border">
              <i class="fa fa-user"></i>
              <h3 class="box-title">
                <span>{{$ml.get("visitorCards.visitorCardList")}}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <div
                v-show="employeeList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table">
                  <thead>
                    <tr>
                      <th @click="setOrderEmp(1)" style="cursor:pointer;min-width:75px;">
                        <strong>
                          {{$ml.get('employees.registrationNumberInfo')}}
                          <i
                            v-show="orderEmpList == 1"
                            class="fa fa-sort-numeric-asc"
                          ></i>
                          <i v-show="orderEmpList == 2" class="fa fa-sort-numeric-desc"></i>
                        </strong>
                      </th>
                      <th @click="setOrderEmp(2)" style="cursor:pointer;">
                        <strong>
                          {{$ml.get('employees.nameSurname')}}
                          <i
                            v-show="orderEmpList == 3"
                            class="fa fa-sort-alpha-asc"
                          ></i>
                          <i v-show="orderEmpList == 4" class="fa fa-sort-alpha-desc"></i>
                        </strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :class="employee.id == employee1.id ? 'bg-primary': ''"
                      style="cursor:pointer;"
                      @click="getEmployee(employee1.id)"
                      v-for="employee1 in filtered"
                      :key="employee1.id"
                    >
                      <td>{{employee1.sicilNo}}</td>
                      <td>
                        {{employee1.name}}
                        <span v-show="employee1.title">({{employee1.title}})</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="employeeList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{$ml.get("visitorCards.visitorCardSearchNotFound")}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingEmployee">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-9">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get("visitorCards.visitorCardInfo")}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button
                  @click="newEmployee()"
                  type="button"
                  class="btn btn-sm btn-warning"
                >{{$ml.get("visitorCards.newVisitorCard")}}</button>
              </div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-3">
                  <div class="box box-primary">
                    <div class="box-body box-profile">
                      <img
                        class="profile-user-img img-responsive img-circle"
                        :src="(this.employee.image == null && this.tempUrl == null) || (this.employee.image == '' && this.tempUrl == null) ? '/src/assets/default-user.png' : this.employee.image || this.tempUrl"
                        style="height:150px;width:150px;"
                      />
                      <div class="text-center">
                        <a
                          href="#"
                          v-show="this.tempUrl || this.employee.image"
                          @click="removeImage()"
                          class="text-red"
                        >
                          <i class="fa fa-remove"></i>
                          {{$ml.get('visitorCards.removePhoto')}}
                        </a>
                      </div>
                      <hr />
                      <my-upload
                        field="img"
                        @crop-success="cropSuccess"
                        langType="tr"
                        v-model="showImageDialog"
                        :width="100"
                        :height="100"
                        url="/images"
                        :params="params"
                        :headers="headers"
                        img-format="png"
                      ></my-upload>
                      <button
                        type="button"
                        @click="toggleShow()"
                        class="btn btn-primary btn-sm"
                        style="width:100%"
                      >
                        <i class="fa fa-upload"></i>
                        {{$ml.get('visitorCards.selectPhoto')}}
                      </button>
                      <hr />
                      <h3 class="profile-username text-center">
                        <span v-show="employee.name != ''">{{employee.name}}</span>
                        <span
                          v-show="this.employee.isActive == false"
                          class="badge label-danger"
                        >{{$ml.get('visitorCards.deletedRecord')}}</span>
                      </h3>
                      <p class="text-muted text-center">
                        <span v-show="employee.title != ''">{{employee.title}}</span>
                      </p>
                      <p class="text-muted text-center">
                        <span
                          v-show="employee.departmentId != null"
                        >{{getDepartmentFromId(employee.departmentId)}}</span>
                      </p>
                      <ul class="list-group list-group-unbordered">
                        <li class="list-group-item">
                          <b>
                            <span>{{$ml.get('visitorCards.registrationNumber')}}</span> :
                          </b>
                          <a class="pull-right">
                            <span v-show="employee.sicilNo == ''">-</span>
                            <span v-show="employee.sicilNo != ''">{{employee.sicilNo}}</span>
                          </a>
                        </li>
                        <li class="list-group-item">
                          <b>
                            <span>{{$ml.get('visitorCards.dateOfCreate')}}</span> :
                          </b>
                          <a class="pull-right">
                            <span v-show="employee.startDate == null">-</span>
                            <span
                              v-show="employee.startDate != ''"
                            >{{employee.startDate | toDateFormatGet("gg.aa.yyyy")}}</span>
                          </a>
                        </li>
                        <li class="list-group-item">
                          <div class="justify-between-content text-center">
                            <img
                              style="width:30px; margin:5px;"
                              :title="employee.hasPassword ? $ml.get('visitorCards.passwordExist') : $ml.get('visitorCards.passwordNotExist')"
                              :src="employee.hasPassword ? '/src/assets/password-true.png' : '/src/assets/password-false.png'"
                            />
                            <img
                              style="width:30px; margin:5px;"
                              :title="employee.hasCard ? $ml.get('visitorCards.cardNumberExist') : $ml.get('visitorCards.cardNumberNotExist')"
                              :src="employee.hasCard ? '/src/assets/card-true.png' : '/src/assets/card-false.png'"
                            />
                            <img
                              style="width:30px; margin:5px;"
                              :title="employee.hasFinger ? $ml.get('visitorCards.fingerprintExist') : $ml.get('visitorCards.fingerprintNotExist')"
                              :src="employee.hasFinger ? '/src/assets/fingerprint-true.png' : '/src/assets/fingerprint-false.png'"
                            />
                            <img
                              style="width:30px; margin:5px;"
                              :title="employee.hasFace ? $ml.get('visitorCards.faceTemplateExist') : $ml.get('visitorCards.faceTemplateNotExist')"
                              :src="employee.hasFace ? '/src/assets/face-true.png' : '/src/assets/face-false.png'"
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li class="active">
                        <a
                          href="#temel-bilgiler"
                          data-toggle="tab"
                          aria-expanded="true"
                        >{{$ml.get('visitorCards.generalInformation')}}</a>
                      </li>
                      <li>
                        <a
                          v-show="modules.visitorAccessGroups"
                          href="#yetkiler"
                          data-toggle="tab"
                          aria-expanded="true"
                        >{{$ml.get('visitorCards.accessAuthorities')}}</a>
                      </li>
                      <li>
                        <a
                          href="#hareketler"
                          data-toggle="tab"
                          aria-expanded="true"
                        >{{$ml.get('visitorCards.movements')}}</a>
                      </li>
                      <!--<li v-show="employee.isVisitor == false">
                        <a href="#yemek-grubu" data-toggle="tab" aria-expanded="true">{{$ml.get('visitorCards.foodGroup')}}</a>
                      </li>-->
                      <li>
                        <a
                          href="#islem-gecmisi"
                          data-toggle="tab"
                          aria-expanded="true"
                        >{{$ml.get('visitorCards.employeeLogs')}}</a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div class="tab-pane active" id="temel-bilgiler">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{$ml.get('visitorCards.registrationNumberInfo')}}</label>
                              <div class="input-group">
                                <input
                                  v-model="employee.sicilNo"
                                  type="text"
                                  class="form-control"
                                  autocomplete="off"
                                />
                                <span class="input-group-btn">
                                  <button
                                    @click="getNewSicilveTerminalNo()"
                                    class="btn btn-primary"
                                  >
                                    <i class="fa fa-refresh"></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{$ml.get('visitorCards.visitorCardGroup')}}</label>
                              <div class="input-group">
                                <select
                                  @change="changeVisitorCardGroup($event)"
                                  class="form-control"
                                >
                                  <option
                                    :selected="employee.visitorCardGroupId == null"
                                    value
                                  >{{$ml.get('general.select')}}</option>
                                  <option
                                    v-for="visitorCardGroup in visitorCardGroupList"
                                    :key="visitorCardGroup.id"
                                    :value="visitorCardGroup.id"
                                    :selected="visitorCardGroup.id == employee.visitorCardGroupId"
                                  >{{visitorCardGroup.name}}</option>
                                </select>
                                <div class="input-group-btn">
                                  <button
                                    class="btn btn-primary"
                                    data-toggle="modal"
                                    data-target="#modal-visitor-card-group"
                                  >
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{$ml.get('visitorCards.cardName')}}</label>
                              <input
                                v-model="employee.name"
                                type="text"
                                class="form-control"
                                autocomplete="off"
                              />
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{$ml.get('visitorCards.department')}}</label>
                              <div class="input-group">
                                <label
                                  id="selectedNode"
                                  @click="selectNode()"
                                  v-show="employee.departmentId != null && employee.departmentId != 0"
                                  class="form-control"
                                >{{getDepartmentFromId(employee.departmentId)}}</label>
                                <label
                                  v-show="employee.departmentId == null || employee.departmentId == 0"
                                  class="form-control"
                                >{{$ml.get('general.notSelected')}}</label>
                                <div class="input-group-btn">
                                  <button
                                    class="btn btn-primary"
                                    data-toggle="modal"
                                    data-target="#select-department"
                                  >
                                    <i class="fa fa-search"></i>
                                  </button>
                                  <button
                                    v-show="employee.departmentId != null && employee.departmentId != ''"
                                    class="btn btn-danger"
                                    @click="employee.departmentId = null"
                                  >
                                    <i class="fa fa-remove"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{$ml.get('visitorCards.dateOfCreateInfo')}}</label>
                              <input type="date" class="form-control" v-model="employee.startDate" />
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group" style="margin-bottom:5px;">
                              <label>{{$ml.get('visitorCards.status')}}</label>
                              <div :class="authControl == 0 ? 'input-group' : 'form-group'">
                                <select @change="changeStatus($event)" class="form-control">
                                  <option
                                    :selected="employee.statuId == null"
                                    value
                                  >{{$ml.get('general.select')}}</option>
                                  <option
                                    v-for="statu in statuList"
                                    :key="statu.id"
                                    :value="statu.id"
                                    :selected="statu.id == employee.statuId"
                                  >{{statu.name}}</option>
                                </select>
                                <span class="input-group-btn" v-show="authControl == 0">
                                  <button
                                    data-toggle="modal"
                                    data-target="#modal-statu"
                                    class="btn btn-primary"
                                  >
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{$ml.get('visitorCards.deviceEmployeeNumber')}}</label>
                              <div class="input-group">
                                <input
                                  v-model="employee.terminalNo"
                                  type="text"
                                  class="form-control"
                                />
                                <span class="input-group-btn">
                                  <button
                                    @click="getNewSicilveTerminalNo()"
                                    class="btn btn-primary"
                                  >
                                    <i class="fa fa-refresh"></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{$ml.get('visitorCards.deviceStatus')}}</label>
                              <select @change="changeTerminalStatu($event)" class="form-control">
                                <option :selected="employee.terminalStatu == 0" :value="0">User</option>
                                <option :selected="employee.terminalStatu == 3" :value="3">Admin</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{$ml.get('visitorCards.deviceCardNo')}}</label>
                              <input
                                v-model="employee.cardNo"
                                type="text"
                                class="form-control"
                                autocomplete="off"
                              />
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{$ml.get('visitorCards.devicePassword')}}</label>
                              <input
                                v-model="employee.terminalPassword"
                                type="text"
                                class="form-control"
                                autocomplete="off"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--GENEL BİLGİLER SONU-->
                      <div class="tab-pane" id="yetkiler" v-show="modules.visitorAccessGroups">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>{{$ml.get('visitorCards.accessAuthoritiesInfo')}}</label>
                              <select
                                @change="changeAccessGroups($event)"
                                class="form-control"
                                style="margin-bottom:5px;"
                              >
                                <option
                                  :selected="employee.accessGroupId == null"
                                  value
                                >{{$ml.get('general.select')}}</option>
                                <option
                                  v-for="acc in accessGroupList"
                                  :key="acc.id"
                                  :value="acc.id"
                                  :selected="acc.id == employee.accessGroupId"
                                >{{acc.name}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <button
                              :disabled="isNewEmployee || authControl == 1"
                              v-show="employee.isActive != false"
                              @click="sendUserToDevices()"
                              class="btn btn-sm btn-primary"
                            >
                              <i class="fa fa-refresh"></i>
                              {{$ml.get('visitorCards.sendPersontoDevices')}}
                            </button>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="box-header">
                              <h4 class="box-title">{{$ml.get('visitorCards.deviceList')}}</h4>
                              <div class="pull-right box-tools">
                                <!--<button
                                  @click="checkReaders()"
                                  class="btn btn-sm btn-primary "
                                >
                                  <span v-show="!isCheck">{{$ml.get('general.selectAll')}}</span>
                                  <span v-show="isCheck">{{$ml.get('general.removeAll')}}</span>
                                </button>-->
                              </div>
                            </div>
                            <div
                              v-show="readerList.length > 0"
                              class="table-responsive no-padding"
                              :style="windowHeightSize"
                            >
                              <table class="table table-hover">
                                <tbody>
                                  <tr v-for="reader in activeReaderList" :key="reader.id">
                                    <td style="font-size:18px;">
                                      <i
                                        v-if="reader.check"
                                        class="fa fa-check-circle text-success"
                                      ></i>
                                      <i v-else class="fa fa-times-circle text-danger"></i>
                                    </td>
                                    <td>{{reader.ipAddress}}</td>
                                    <td>{{reader.readerNo}} - {{reader.name}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div v-show="readerList.length == 0" class="callout callout-info">
                              <i class="fa fa-info-circle"></i>
                              {{$ml.get('visitorCards.deviceNotRecord')}}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--YETKİLER SONU-->
                      <div class="tab-pane" id="hareketler">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3 class="box-title">{{$ml.get('visitorCards.movements')}}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <button
                                      v-show="inOutList.length > 0 && authControl == 0"
                                      @click="exportToPDFHareketler()"
                                      type="button"
                                      class="btn btn-danger btn-sm"
                                    >
                                      <i class="fa fa-share"></i>
                                      {{$ml.get('general.exportToPdfOrPrint')}}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div class="pull-left" style="margin-bottom:5px">
                                  <button
                                    type="button"
                                    @click="changeInOutListDoorType(3)"
                                    :class="inOut.inOutListDoorType == 3 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm'"
                                  >
                                    <i class="fa fa-thumb-tack text-blue"></i>
                                    {{$ml.get('visitorCards.allDoors')}}
                                  </button>
                                  <button
                                    type="button"
                                    @click="changeInOutListDoorType(1)"
                                    :class="inOut.inOutListDoorType == 1 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm'"
                                  >
                                    <i class="fa fa-hourglass-2 text-blue"></i>
                                    {{$ml.get('visitorCards.pdks')}}
                                  </button>
                                  <button
                                    type="button"
                                    @click="changeInOutListDoorType(0)"
                                    :class="inOut.inOutListDoorType == 0 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm'"
                                  >
                                    <i class="fa fa-id-card text-blue"></i>
                                    {{$ml.get('visitorCards.access')}}
                                  </button>
                                  <button
                                    v-show="modules.diningHall"
                                    type="button"
                                    @click="changeInOutListDoorType(2)"
                                    :class="inOut.inOutListDoorType == 2 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm'"
                                  >
                                    <i class="fa fa-cutlery text-blue"></i>
                                    {{$ml.get('visitorCards.diningHall')}}
                                  </button>
                                </div>
                                <div class="pull-right" style="margin-bottom:5px">
                                  <button
                                    type="button"
                                    @click="changeInOutListType(0)"
                                    :class="inOut.inOutListType == 0 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm'"
                                  >
                                    <i class="fa fa-square text-blue"></i>
                                    {{$ml.get('visitorCards.all')}}
                                  </button>
                                  <button
                                    type="button"
                                    @click="changeInOutListType(1)"
                                    :class="inOut.inOutListType == 1 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm'"
                                  >
                                    <i class="fa fa-square text-green"></i>
                                    {{$ml.get('visitorCards.active')}}
                                  </button>
                                  <button
                                    type="button"
                                    @click="changeInOutListType(2)"
                                    :class="inOut.inOutListType == 2 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm'"
                                  >
                                    <i class="fa fa-square text-red"></i>
                                    {{$ml.get('visitorCards.passive')}}
                                  </button>
                                </div>
                                <div class="row" style="margin-top:5px">
                                  <div
                                    class="col-md-12 col-lg-6 col-sm-12"
                                    style="margin-bottom:10px"
                                  >
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{$ml.get('visitorCards.startDateMovements')}}</span> :
                                        </button>
                                      </div>
                                      <input
                                        v-model="inOut.inOutStartDate"
                                        type="datetime-local"
                                        class="form-control"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    class="col-md-12 col-lg-6 col-sm-12"
                                    style="margin-bottom:5px;"
                                  >
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{$ml.get('visitorCards.endDateMovements')}}</span> :
                                        </button>
                                      </div>
                                      <input
                                        v-model="inOut.inOutEndDate"
                                        type="datetime-local"
                                        class="form-control"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div
                                    class="col-sm-12"
                                    style="margin-bottom:10px; text-align:center"
                                  >
                                    <button
                                      :disabled="isLoadingInOuts"
                                      @click="getInOuts()"
                                      type="button"
                                      class="btn btn-primary btn-sm"
                                      style="width:90%"
                                    >
                                      <i class="fa fa-search"></i>
                                      {{$ml.get('visitorCards.searchMovements')}}
                                    </button>
                                  </div>
                                </div>
                                <div class="row col-sm-12" style="margin: 0px 5px 10px 0px;">
                                  <div
                                    id="printHareketler"
                                    v-show="inOutList.length > 0"
                                    class="table-responsive no-padding"
                                    style="max-height:350px;owerflow:auto;"
                                  >
                                    <div align="center">
                                      <span
                                        v-show="inOutList.length > 0"
                                      >{{employee.sicilNo}} - {{employee.name}} ({{this.inOut.inOutStartDate | toDateFormatGet("gg.aa.yyyy ss:dd")}} - {{this.inOut.inOutEndDate | toDateFormatGet("gg.aa.yyyy ss:dd")}})</span>
                                    </div>
                                    <table class="table table-hover">
                                      <tbody>
                                        <tr>
                                          <th
                                            style="width:130px"
                                          >{{$ml.get('visitorCards.timeMovement')}}</th>
                                          <th>{{$ml.get('visitorCards.deviceMovement')}}</th>
                                          <th>{{$ml.get('visitorCards.statusMovement')}}</th>
                                          <th style="width:30px"></th>
                                        </tr>
                                        <tr v-for="inOut2 in inOutFiltered" :key="inOut2.id">
                                          <td>{{inOut2.date | toDateFormatGet("gg.aa.yyyy ss:dd")}}</td>
                                          <td>
                                            <span
                                              v-show="inOut2.readerId != 0"
                                            >{{inOut2.readerName}}</span>
                                            <span
                                              v-show="inOut2.readerId == 0"
                                            >{{$ml.get('visitorCards.manuelMovement')}}</span>
                                          </td>
                                          <td>
                                            <span
                                              v-show="inOut2.inOrOut != 2"
                                              class="label btn-success"
                                            >{{$ml.get('visitorCards.entryMovement')}}</span>
                                            <span
                                              v-show="inOut2.inOrOut == 2"
                                              class="label btn-danger"
                                            >{{$ml.get('visitorCards.exitMovement')}}</span>
                                          </td>
                                          <td>
                                            <span
                                              v-show="!inOut2.isActive"
                                              class="badge"
                                            >{{$ml.get('visitorCards.passive')}}</span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div v-show="inOutList.length == 0" class="callout callout-info">
                                    <i class="fa fa-info-circle"></i>
                                    {{$ml.get('visitorCards.movementNotRecord')}}
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-body -->
                              <div class="overlay" id="load" :hidden="!isLoadingInOuts">
                                <i class="fa fa-refresh fa-spin"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--HAREKETLER SONU-->
                      <!--<div class="tab-pane" id="yemek-grubu">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>{{$ml.get('visitorCards.foodGroup')}}</label>
                              <select @change="changeFoodGroup($event)" class="form-control">
                                <option :selected="employee.foodGroupId == 0" :value="0">{{$ml.get('general.notSelected')}}</option>
                                <option
                                  v-for="foodGroup in foodGroupList"
                                  :key="foodGroup.id"
                                  :selected="employee.foodGroupId == foodGroup.id"
                                  :value="foodGroup.id"
                                >{{foodGroup.name}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{$ml.get('visitorCards.remainingCredits')}}</label>
                              <div class="input-group">
                                <label v-text="employee.credit" class="form-control"></label>
                                <span class="input-group-btn">
                                  <button
                                    @click="selectFoodType(1, employee.credit)"
                                    data-toggle="modal"
                                    data-target="#modal-yemek"
                                    class="btn btn-primary "
                                  >
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{$ml.get('visitorCards.availableBalance')}}</label>
                              <div class="input-group">
                                <label v-text="employee.remainder" class="form-control"></label>
                                <span class="input-group-btn">
                                  <button
                                    @click="selectFoodType(2, employee.remainder)"
                                    data-toggle="modal"
                                    data-target="#modal-yemek"
                                    class="btn btn-primary "
                                  >
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>-->
                      <!--YEMEK GRUBU SONU-->
                      <div class="tab-pane" id="islem-gecmisi">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3 class="box-title">{{$ml.get('visitorCards.employeeLogs')}}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <button
                                      v-show="logList.length > 0 && authControl == 0"
                                      @click="exportToPDFLogs()"
                                      type="button"
                                      class="btn btn-danger btn-sm"
                                    >
                                      <i class="fa fa-share"></i>
                                      {{$ml.get('general.exportToPdfOrPrint')}}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div class="row" style="margin-top:5px">
                                  <div
                                    class="col-md-12 col-lg-6 col-sm-12"
                                    style="margin-bottom:10px"
                                  >
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{$ml.get('visitorCards.startDateLogs')}}</span> :
                                        </button>
                                      </div>
                                      <input
                                        v-model="logStartDate"
                                        type="datetime-local"
                                        class="form-control"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    class="col-md-12 col-lg-6 col-sm-12"
                                    style="margin-bottom:5px;"
                                  >
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{$ml.get('visitorCards.endDateLogs')}}</span> :
                                        </button>
                                      </div>
                                      <input
                                        v-model="logEndDate"
                                        type="datetime-local"
                                        class="form-control"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div
                                    class="col-sm-12"
                                    style="margin-bottom:10px; text-align:center"
                                  >
                                    <button
                                      :disabled="isNewEmployee && isLoadingLogs"
                                      type="button"
                                      @click="getLogs()"
                                      class="btn btn-primary btn-sm"
                                      style="width:90%"
                                    >
                                      <i class="fa fa-search"></i>
                                      {{$ml.get('visitorCards.searchLogs')}}
                                    </button>
                                  </div>
                                </div>
                                <div class="row col-sm-12" style="margin: 0px 5px 10px 0px;">
                                  <div
                                    id="printLogs"
                                    v-show="logList.length > 0"
                                    class="table-responsive no-padding"
                                    style="max-height:350px;owerflow:auto;"
                                  >
                                    <div align="center">
                                      <span
                                        v-show="logList.length > 0"
                                      >{{employee.sicilNo}} - {{employee.name}} ({{this.logStartDate | toDateFormatGet("gg.aa.yyyy ss:dd")}} - {{this.logEndDate | toDateFormatGet("gg.aa.yyyy ss:dd")}})</span>
                                    </div>
                                    <table class="table table-hover">
                                      <tbody>
                                        <tr>
                                          <th
                                            style="width:120px;"
                                          >{{$ml.get('visitorCards.timeLog')}}</th>
                                          <th>{{$ml.get('visitorCards.descriptionLog')}}</th>
                                        </tr>
                                        <tr v-for="log in logList" :key="log.id">
                                          <td>{{log.date | toDateFormatGet("gg.aa.yyyy ss:dd")}}</td>
                                          <td>{{log.description}}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div v-show="logList.length == 0" class="callout callout-info">
                                    <i class="fa fa-info-circle"></i>
                                    {{$ml.get('visitorCards.logNotRecord')}}
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-body -->
                              <div class="overlay" id="load" :hidden="!isLoadingLogs">
                                <i class="fa fa-refresh fa-spin"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--İŞLEM GEÇMİŞİ SONU-->
                    </div>
                  </div>
                  <!-- NAV TABS END -->
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button
                  v-show="!isNewEmployee && employee.isActive != false && authControl == 0"
                  type="button"
                  value="Sil"
                  class="btn btn-sm btn-danger"
                  style="margin: 5px; width:120px;"
                  data-toggle="modal"
                  data-target="#modal-sil"
                >{{$ml.get('general.delete')}}</button>
                <button
                  v-show="isNewEmployee && employee.isActive != false && authControl == 0"
                  type="button"
                  class="btn btn-sm btn-success"
                  style="margin: 5px; width:120px;"
                  data-toggle="modal"
                  data-target="#modal-kaydet"
                >{{$ml.get('general.save')}}</button>
                <button
                  v-show="!isNewEmployee && employee.isActive != false && authControl == 0"
                  type="button"
                  class="btn btn-sm btn-success"
                  style="margin: 5px; width:120px;"
                  data-toggle="modal"
                  data-target="#modal-guncelle"
                >{{$ml.get('general.update')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('visitorCards.updateVisitorCard')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.employee.name}}</span>
                <span v-show="this.employee.title != ''">- {{this.employee.title}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('visitorCards.isContinueUpdateVisitorCard')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveEmployee()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{$ml.get('general.update')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('visitorCards.saveVisitorCard')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{this.employee.name}}</p>
              <span>{{$ml.get('visitorCards.isContinueSaveVisitorCard')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveEmployee()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{$ml.get('general.save')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('visitorCards.deleteVisitorCard')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.employee.name}}</span>
                <span v-show="this.employee.title != ''">- {{this.employee.title}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('visitorCards.isContinueDeleteVisitorCard')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="deleteEmployee()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{$ml.get('general.delete')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!--YEMEK MODAL -->
      <div class="modal modal-primary fade" id="modal-yemek" style="display: none;">
        <div class="modal-dialog modal-dialog-centered modal-sm">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span v-show="selectedFoodType == 1">{{$ml.get('visitorCards.addCredit')}}</span>
                <span v-show="selectedFoodType == 2">{{$ml.get('visitorCards.addBalance')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div v-show="selectedFoodType == 1">
                <p class="margin">{{$ml.get('visitorCards.amountOfCredit')}}</p>
                <div class="input-group">
                  <div class="input-group-btn">
                    <button
                      type="button"
                      class="btn btn-danger"
                      @click="selectedFoodCount > 0 ? selectedFoodCount -= 1 : selectedFoodCount"
                    >
                      <i class="fa fa-minus"></i>
                    </button>
                  </div>
                  <input
                    v-model="selectedFoodCount"
                    type="number"
                    min="0"
                    value="0"
                    class="form-control"
                  />
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-success" @click="selectedFoodCount += 1">
                      <i class="fa fa-plus"></i>
                    </button>
                  </span>
                </div>
              </div>
              <div v-show="selectedFoodType == 2" class="input-group">
                <p class="margin">{{$ml.get('visitorCards.amountOfBalance')}}</p>
                <input v-model="selectedFoodCount" type="text" class="form-control" />
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline pull-left"
                data-dismiss="modal"
              >{{$ml.get('general.cancel')}}</button>
              <button
                type="button"
                @click="updateFoodCredit()"
                class="btn btn-outline btn-success"
                data-dismiss="modal"
              >
                <span>{{$ml.get('general.save')}}</span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--YEMEK MODAL END -->
      <!--ZİYARETÇİ KART GRUBU MODAL -->
      <div class="modal modal-primary fade" id="modal-visitor-card-group" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('visitorCards.visitorCardGroups')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-5">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h4 class="box-title">{{$ml.get('visitorCards.cardGroupList')}}</h4>
                      <div class="pull-right box-tools">
                        <button
                          @click="newVisitorCardGroup()"
                          class="btn btn-sm btn-warning"
                        >{{$ml.get('visitorCards.newCardGroup')}}</button>
                      </div>
                    </div>
                    <div class="box-body">
                      <div
                        v-show="visitorCardGroupList.length > 0"
                        class="table-responsive no-padding"
                        :style="windowHeightTableSize"
                      >
                        <table class="table table-hover">
                          <tbody>
                            <tr v-for="visitorGroup in visitorCardGroupList" :key="visitorGroup.id">
                              <td>{{visitorGroup.name}}</td>
                              <td>
                                <button
                                  @click="selectVisitorCardGroup(visitorGroup.id, visitorGroup.name, visitorGroup.devices)"
                                  class="btn btn-sm btn-primary"
                                >
                                  <i class="fa fa-search"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="visitorCardGroupList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{$ml.get('visitorCards.visitorCardGroupNotFound')}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-7">
                  <div class="form-group">
                    <label>{{$ml.get('visitorCards.cardGroupName')}}</label>
                    <input v-model="selectedVisitorCardGroupName" type="text" class="form-control" />
                  </div>
                  <div
                    v-show="readerList.length > 0"
                    class="table-responsive no-padding"
                    :style="windowHeightTableSize"
                  >
                    <table class="table table-hover" style="background-color:white;">
                      <tbody>
                        <tr
                          style="cursor:pointer;"
                          v-for="reader in activeReaderList"
                          :key="reader.id"
                          @click="reader.VCGcheck ? reader.VCGcheck = false : reader.VCGcheck = true"
                        >
                          <td style="font-size:18px;">
                            <i v-if="reader.VCGcheck" class="fa fa-check-circle text-success"></i>
                            <i v-else class="fa fa-times-circle text-danger"></i>
                          </td>
                          <td style="padding-top:10px;">{{reader.ipAddress}}</td>
                          <td style="padding-top:10px;">{{reader.readerNo}} - {{reader.name}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-show="readerList.length == 0" class="callout callout-info">
                    <i class="fa fa-info-circle"></i>
                    {{$ml.get('visitorCards.readerNotFound')}}
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline pull-left"
                data-dismiss="modal"
              >{{$ml.get('general.cancel')}}</button>
              <button
                v-show="!isNewVisitorCardGroup"
                type="button"
                @click="deleteVisitorCardGroup()"
                class="btn btn-outline btn-danger"
              >
                <span>{{$ml.get('general.delete')}}</span>
              </button>
              <button
                type="button"
                @click="saveVisitorCardGroup()"
                class="btn btn-outline btn-success"
              >
                <span v-show="isNewVisitorCardGroup">{{$ml.get('general.save')}}</span>
                <span v-show="!isNewVisitorCardGroup">{{$ml.get('general.update')}}</span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ZİYARETÇİ KART GRUBU MODAL END -->
      <!--STATU MODAL -->
      <div class="modal modal-primary fade" id="modal-statu" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('visitorCards.statusTitle')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-5">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h4 class="box-title">{{$ml.get('visitorCards.statusList')}}</h4>
                      <div class="pull-right box-tools">
                        <button
                          @click="newStatu()"
                          class="btn btn-sm btn-warning"
                        >{{$ml.get('visitorCards.newStatus')}}</button>
                      </div>
                    </div>
                    <div class="box-body">
                      <div
                        v-show="statuList.length > 0"
                        class="table-responsive no-padding"
                        style="max-height:250px; overflow:auto; color:black;"
                      >
                        <table class="table table-hover">
                          <tbody>
                            <tr v-for="statu in statuList" :key="statu.id">
                              <td>{{statu.name}}</td>
                              <td>
                                <button
                                  @click="selectStatu(statu.id, statu.name)"
                                  class="btn btn-sm btn-primary"
                                >
                                  <i class="fa fa-search"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="statuList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{$ml.get('visitorCards.statusNotRecord')}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-7">
                  <div class="form-group">
                    <label>{{$ml.get('visitorCards.statusName')}}</label>
                    <input v-model="selectedStatuName" type="text" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline pull-left"
                data-dismiss="modal"
              >{{$ml.get('general.cancel')}}</button>
              <button
                v-show="!isNewStatu"
                type="button"
                @click="deleteStatu()"
                class="btn btn-outline btn-danger"
              >
                <span>{{$ml.get('general.delete')}}</span>
              </button>
              <button type="button" @click="saveStatu()" class="btn btn-outline btn-success">
                <span v-show="isNewStatu">{{$ml.get('general.save')}}</span>
                <span v-show="!isNewStatu">{{$ml.get('general.update')}}</span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--STATU MODAL END -->
      <!--DEPARTMAN MODAL -->
      <div class="modal modal-primary fade" id="select-department" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('visitorCards.selectDepartment')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div
                v-show="departmentList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <div id="treeview"></div>
              </div>
              <div v-show="departmentList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{$ml.get('visitorCards.departmentNotRecord')}}
              </div>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DEPARTMAN MODAL END -->
    </section>
  </div>
</template>

<script>
import myUpload from "vue-image-crop-upload";
export default {
  data() {
    return {
      isLoading: false,
      isLoadingInOuts: false,
      isLoadingLogs: false,
      isLoadingEmployee: false,
      orderEmpList: 1,
      windowHeight: window.innerHeight,
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: true,
        isActive: true
      },
      employee: {
        id: null,
        name: "",
        title: "",
        sicilNo: "",
        image: null,
        departmentId: null,
        identityNo: "",
        startDate: null,
        endDate: null,
        workGroupId: null,
        stateId: 1,
        stateNote: "",
        terminalNo: null,
        statuId: null,
        cardNo: "",
        terminalStatu: 0,
        terminalPassword: "",
        accessGroupId: null,
        readers: [],
        overWorkStatus: true,
        salary: null,
        mail: "",
        address: "",
        mobilePhone: "",
        birthDayDate: null,
        internalPhone: "",
        homePhone: "",
        gender: null,
        educationStatus: null,
        militaryStatus: null,
        drivingLicence: "",
        smokeStatus: null,
        maritalStatus: null,
        bloodType: "",
        height: "",
        weight: "",
        disabledPercent: "",
        authorizedPerson1: null,
        authorizedPerson2: null,
        note1: "",
        note2: "",
        foreignLanguage: "",
        foodGroupId: null,
        credit: 0,
        remainder: "0",
        isVisitor: true,
        visitorCardGroupId: null,
        visitorArea: "",
        isActive: true,
        extrafields: [],
        inOuts: [],
        allowences: [],
        logs: [],
        empPayrolls: [],
        annualPermitId: 0,
        annualPermitSeniority: 0,
        annualPermitTransfer: 0,
        annualPermitClaim: 0,
        annualPermitUsed: 0,
        annualPermitRemain: 0,
        annualPermits: [],
        annualPermitClaimsDates: [],
        salaries: [],
        hasCard: false,
        hasFace: false,
        hasFinger: false,
        hasPassword: false,
        roomId: 0,
        roomName: "",
        areaName: "",
        floorName: "",
        fingerIndexes: [],
        isSmsSend: false,
        parentPhone: null,
        isStudent: false,
        isStayInDormitory: false,
        motherName: "",
        motherPhone: "",
        fatherName: "",
        fatherPhone: "",
        isMobileUser: false,
        mobilePassword: ""
      },
      inOut: {
        inOutId: null,
        inOutListType: 0,
        inOutListDoorType: 3,
        inOutType: 0,
        inOutAdd: "",
        readerId: "0",
        inOutStartDate: null,
        inOutEndDate: null
      },
      sortableDepTrees: [],
      selectedFoodType: 1,
      selectedFoodCount: "0",
      isNewStatu: true,
      selectedStatuId: null,
      selectedStatuName: "",
      logStartDate: null,
      logEndDate: null,
      status: [],
      foodGroups: [],
      accessGroups: [],
      departments: [],
      employees: [],
      allEmployees: [],
      visitorCardGroups: [],
      isNewVisitorCardGroup: true,
      selectedVisitorCardGroupId: null,
      selectedVisitorCardGroupName: "",
      selectedVisitorCardGroupDevices: [],
      searchText2: "",
      readers: [],
      isCheck: false,
      isCheckDeps: false,
      searchText: "",
      isNewEmployee: true,
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {}
    };
  },
  components: {
    "my-upload": myUpload
  },
  filters: {
    toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    modules() {
      return this.$store.getters.getModules;
    },
    authControl() {
      return this.$store.getters.getAuthKisiler;
    },
    logList() {
      return this.employee.logs;
    },
    readerList() {
      return this.readers.sort((a, b) => {
        if (a.ipAddress < b.ipAddress) return -1;
        if (a.ipAddress > b.ipAddress) return 0;
      });
    },
    activeReaderList() {
      return this.readerList.filter(item => {
        return item.isActive == true;
      });
    },
    activePDKSReaderList() {
      return this.readerList.filter(item => {
        return item.isActive == true && item.doorType == 1;
      });
    },
    visitorCardGroupList() {
      return this.visitorCardGroups;
    },
    departmentList() {
      return this.departments;
    },
    sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    employeeList() {
      if (this.orderEmpList == 1) {
        return this.employees.sort((a, b) => {
          return a.sicilNo.toUpperCase().localeCompare(b.sicilNo.toUpperCase());
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort((a, b) => {
          return b.sicilNo.toUpperCase().localeCompare(a.sicilNo.toUpperCase());
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort((a, b) => {
          return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
        });
      } else {
        return this.employees.sort((a, b) => {
          return b.name.toUpperCase().localeCompare(a.name.toUpperCase());
        });
      }
    },
    allEmployeeList() {
      return this.allEmployees;
    },
    foodGroupList() {
      return this.foodGroups;
    },
    statuList() {
      return this.status;
    },
    accessGroupList() {
      return this.accessGroups;
    },
    inOutList() {
      return this.employee.inOuts;
    },
    allEmployeeFilteredList() {
      var search = this.turkishToUpper(this.searchText2);
      if (search) {
        return this.allEmployeeList.filter(item => {
          return search
            .split(" ")
            .every(
              v =>
                this.turkishToUpper(item.name).includes(v) ||
                this.turkishToUpper(item.sicilNo).includes(v)
            );
        });
      } else {
        return this.allEmployeeList;
      }
    },
    filtered() {
      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.employeeList.filter(item => {
          return search
            .split(" ")
            .every(
              v =>
                this.turkishToUpper(item.name).includes(v) ||
                this.turkishToUpper(item.sicilNo).includes(v)
            );
        });
      } else {
        return this.employeeList;
      }
    },
    inOutFiltered() {
      if (this.inOut.inOutListType == 0) {
        if (this.inOut.inOutListDoorType == 3) {
          return this.inOutList;
        } else {
          return this.inOutList.filter(item => {
            return item.doorType == this.inOut.inOutListDoorType;
          });
        }
      }
      if (this.inOut.inOutListType == 1) {
        return this.inOutList.filter(item => {
          if (this.inOut.inOutListDoorType == 3) {
            return item.isActive == true;
          } else {
            return (
              item.isActive == true &&
              item.doorType == this.inOut.inOutListDoorType
            );
          }
        });
      } else if (this.inOut.inOutListType == 2) {
        return this.inOutList.filter(item => {
          if (this.inOut.inOutListDoorType == 3) {
            return item.isActive == false;
          } else {
            return (
              item.isActive == false &&
              item.doorType == this.inOut.inOutListDoorType
            );
          }
        });
      }
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 220;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 420;
        return "max-height:" + height + "px;overflow:auto;color:black;";
      } else {
        return "max-height:370px;overflow:auto;color:black;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function(letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    toggleShow() {
      this.showImageDialog = !this.showImageDialog;
    },
    cropSuccess(imgDataUrl, imgData, mime, field) {
      this.imageData = imgData;
      this.tempUrl = imgDataUrl;
      this.showImageDialog = false;
    },
    exportToPDFLogs() {
      this.$htmlToPaper("printLogs");
    },
    exportToPDFHareketler() {
      this.$htmlToPaper("printHareketler");
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    selectVisitorCardGroup(id, name, devices) {
      this.isNewVisitorCardGroup = false;
      this.selectedVisitorCardGroupId = id;
      this.selectedVisitorCardGroupDevices = devices;
      this.readers.forEach(device => {
        device.VCGcheck = false;
      });
      if (devices) {
        devices.forEach(item => {
          this.readers.forEach(device => {
            if (item == device.readerId) {
              device.VCGcheck = true;
            }
          });
        });
      }
      this.selectedVisitorCardGroupName = name;
    },
    newVisitorCardGroup() {
      this.isNewVisitorCardGroup = true;
      this.readers.forEach(device => {
        device.VCGcheck = false;
      });
      this.selectedVisitorCardGroupId = null;
      this.selectedVisitorCardGroupDevices = [];
      this.selectedVisitorCardGroupName = "";
    },
    async saveVisitorCardGroup() {
      if (this.selectedVisitorCardGroupName == "") {
        alertify.warning(this.$ml.get("alerts.visitorCardGroupNameNotBlank"));
        return;
      }
      try {
        let id = this.selectedVisitorCardGroupId;
        await this.getCheckReaders();
        let name = this.selectedVisitorCardGroupName;
        let devices = this.selectedVisitorCardGroupDevices;
        if (this.isNewVisitorCardGroup == true) {
          const response = await this.$axios
            .post("/VisitorGroups", {
              name: name,
              devices: devices
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newVisitorCardGroup();
          this.getVisitorCardGroups();
        } else {
          const response = await this.$axios
            .post("/VisitorGroups/" + id, {
              id: id,
              name: name,
              devices: devices
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newVisitorCardGroup();
          this.getVisitorCardGroups();
        }
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    deleteVisitorCardGroup() {
      try {
        let id = this.selectedVisitorCardGroupId;
        if (id != null) {
          const response = this.$axios
            .delete("/VisitorGroups/" + id)
            .then(response => {
              this.getVisitorCardGroups();
              this.newVisitorCardGroup();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    selectStatu(id, name) {
      this.isNewStatu = false;
      this.selectedStatuId = id;
      this.selectedStatuName = name;
    },
    newStatu() {
      this.isNewStatu = true;
      this.selectedStatuId = null;
      this.selectedStatuName = "";
    },
    async saveStatu() {
      if (this.selectedStatuName == "") {
        alertify.warning(this.$ml.get("alerts.statusNameNotBlank"));
        return;
      }
      try {
        let id = this.selectedStatuId;
        let name = this.selectedStatuName;
        if (this.isNewStatu == true) {
          const response = await this.$axios
            .post("/Employees/AddStatus", {
              name: name
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newStatu();
          this.getStatus();
        } else {
          const response = await this.$axios
            .post("/Employees/UpdateStatus/" + id, {
              id: id,
              name: name
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newStatu();
          this.getStatus();
        }
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    deleteStatu() {
      try {
        let id = this.selectedStatuId;
        if (id != null) {
          const response = this.$axios
            .delete("/Employees/DeleteStatus/" + id)
            .then(response => {
              this.getStatus();
              this.newStatu();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    saveFoodCount() {
      if (this.selectedFoodType == 1) {
      } else {
      }
    },
    changeInOutListType(number) {
      this.inOut.inOutListType = number;
    },
    changeInOutListDoorType(number) {
      this.inOut.inOutListDoorType = number;
    },
    removeImage() {
      this.imageData = null;
      this.tempUrl = null;
      this.employee.image = null;
    },
    getDepartmentFromId(id) {
      let aList = this.departments;
      let dep = aList.filter(function(department) {
        return department.id == id;
      });
      if (dep != "" && dep != null) {
        return dep[0].name;
      } else {
        return null;
      }
    },
    async getLogs() {
      if ((this.logStartDate == null) | (this.logEndDate == null)) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoadingLogs = true;
        const logs = [];
        var startDate = this.logStartDate;
        var endDate = this.logEndDate;
        let id = this.employee.id;
        const response = await this.$axios.post(
          "/EmployeeDetails/GetOperationLogs",
          {
            id: id,
            startDate: startDate,
            endDate: endDate
          }
        );
        response.data.forEach(doc => {
          logs.push({
            id: doc.id,
            date: doc.date,
            description: doc.description
          });
        });
        this.employee.logs = logs;
        this.isLoadingLogs = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingLogs = false;
      }
    },
    changeVisitorCardGroup(event) {
      this.employee.visitorCardGroupId = event.target.value;
    },
    changeTerminalStatu(event) {
      this.employee.terminalStatu = event.target.value;
    },
    changeFoodGroup(event) {
      this.employee.foodGroupId = event.target.value;
    },
    changeInOutDoor(event) {
      this.inOut.readerId = event.target.value;
    },
    changeInOutType(event) {
      this.inOut.inOutType = event.target.value;
    },
    changeDepartments(event) {
      this.employee.departmentId = event.target.value;
    },
    changeStatus(event) {
      this.employee.statuId = event.target.value;
    },
    changeAccessGroups(event) {
      if (event.target.value != null && event.target.value != 0) {
        this.checkListFromAccessGroup(event.target.value);
      }
      this.employee.accessGroupId = event.target.value;
    },
    selectFoodType(number, value) {
      this.selectedFoodType = number;
      //this.selectedFoodCount = value;
    },
    filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = true;
      this.filters.isActive = true;
    },
    checkReaders() {
      this.isCheck = !this.isCheck;
      let aList = this.readers;
      aList.forEach(doc => {
        if (doc.check == !this.isCheck) {
          doc.check = this.isCheck;
        }
      });
    },
    async getReaders() {
      try {
        const readers = [];
        const response = await this.$axios
          .get("/Terminal/GetReaders")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                if (
                  doc.doorType == 0 ||
                  doc.doorType == 1 ||
                  doc.doorType == 2 ||
                  doc.doorType == 3 ||
                  doc.doorType == 5
                ) {
                  readers.push({
                    readerNo: doc.readerNo,
                    readerId: doc.readerId,
                    terminalId: doc.terminalId,
                    terminalNo: doc.terminalNo,
                    ipAddress: doc.ipAddress,
                    isActive: doc.isActive,
                    doorType: doc.doorType,
                    name: doc.name,
                    check: false,
                    VCGcheck: false
                  });
                }
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
              if (error.response.status == 500) {
                alertify.error(this.$ml.get("alerts.getReadersError"));
                this.isLoading = false;
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.readers = readers;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
      }
    },
    async updateFoodCredit() {
      if (this.selectedFoodCount == null) {
        alertify.warning(this.$ml.get("alerts.creditNotBlank"));
        return;
      }
      try {
        let employeeId = this.employee.id;
        let credit = this.selectedFoodCount.replace(",", ".");
        let creditType = this.selectedFoodType;
        const response = await this.$axios
          .post("/EmployeeDetails/UpdateCredit", {
            employeeId: employeeId,
            creditType: creditType,
            credit: credit
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        this.selectedFoodCount = 0;
        this.getEmployee(employeeId);
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    async getCheckReaders() {
      this.selectedVisitorCardGroupDevices = [];
      await this.readers.forEach(doc => {
        if (doc.VCGcheck == true) {
          this.selectedVisitorCardGroupDevices.push(doc.readerId);
        }
      });
    },
    async sendUserToDevices() {
      this.isLoading = true;
      try {
        var aList = [];
        await this.readers.filter(doc => {
          if (doc.check == true) {
            aList.push(doc.readerId);
          }
        });
        const response = await this.$axios
          .post("/EmployeeDetails/SendUserToDevices", {
            empId: this.employee.id,
            devices: aList
          })
          .then(response => {
            if (response.status == 200) {
              this.isLoading = false;
              alertify.success(
                this.$ml.get("alerts.commandSentToDevicesSuccessfully")
              );
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.isLoading = false;
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              this.isLoading = false;
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              this.isLoading = false;
              alertify.error(doc.message);
            }
          });
      } catch (error) {
        this.isLoading = false;
        console.error(error);
        alertify.error(error.message);
      }
    },
    async GetUserDataFromDevice(readerId) {
      this.isLoading = true;
      try {
        let empId = this.employee.id;
        const response = await this.$axios
          .post("/EmployeeDetails/GetUserDataFromDevice", {
            empId: empId,
            readerId: readerId
          })
          .then(response => {
            if (response.status == 200) {
              this.isLoading = false;
              alertify.success(
                this.$ml.get("alerts.getUserInfoFromTerminalsSuccessfully")
              );
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.isLoading = false;
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              this.isLoading = false;
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              this.isLoading = false;
              alertify.error(doc.message);
            }
          });
      } catch (error) {
        this.isLoading = false;
        console.error(error);
        alertify.error(error.message);
      }
    },
    async SendGetFaceCommand(readerId) {
      this.isLoading = true;
      try {
        let empId = this.employee.id;
        const response = await this.$axios
          .post("/EmployeeDetails/SendGetFaceCommand", {
            empId: empId,
            readerId: readerId
          })
          .then(response => {
            if (response.status == 200) {
              this.isLoading = false;
              alertify.success(
                this.$ml.get("alerts.getFaceTemplateFromSuccessfully")
              );
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.isLoading = false;
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              this.isLoading = false;
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              this.isLoading = false;
              alertify.error(doc.message);
            }
          });
      } catch (error) {
        this.isLoading = false;
        console.error(error);
        alertify.error(error.message);
      }
    },
    async SendGetFingerCommand(readerId) {
      this.isLoading = true;
      try {
        let empId = this.employee.id;
        const response = await this.$axios
          .post("/EmployeeDetails/SendGetFingerCommand", {
            empId: empId,
            readerId: readerId
          })
          .then(response => {
            if (response.status == 200) {
              this.isLoading = false;
              alertify.success(
                this.$ml.get("alerts.getFingerprintsFromTerminalsSuccessfully")
              );
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.isLoading = false;
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              this.isLoading = false;
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              this.isLoading = false;
              alertify.error(doc.message);
            }
          });
      } catch (error) {
        this.isLoading = false;
        console.error(error);
        alertify.error(error.message);
      }
    },
    selectNode() {
      this.isLoading = true;
      let node = document.getElementById("selectedNode").value;
      this.employee.departmentId = this.getDepartmentFromName(node);
      $("#select-department").modal("hide");
      this.isLoading = false;
    },
    getDepartmentFromName(name) {
      let aList = this.departments;
      let dep = aList.filter(function(department) {
        return department.name == name;
      });
      if (dep != "" && dep != null) {
        return dep[0].id;
      } else {
        return null;
      }
    },
    async setTree() {
      let activeUser = await this.$store.getters.getUser;
      let departments = this.departments;
      var root = new TreeNode(
        activeUser.companyName + " (" + this.$ml.get("shared.company") + ")"
      );
      await departments.forEach(doc => {
        if (doc.mainDepartmentId == null) {
          var node = new TreeNode(doc.name);
          root.addChild(node);
          this.addChildDep(node, doc.id);
        }
      });
      var tree = new TreeView(root, "#treeview", {
        leaf_icon: "<i class='fa fa-star'></i>",
        parent_icon: "<i class='fa fa-sitemap'></i>",
        open_icon: "<i class='fa fa-chevron-down'></i>",
        close_icon: "<i class='fa fa-chevron-right'></i>"
      });
    },
    async addChildDep(Tnode, mainDep) {
      let departments = this.departments;
      await departments.forEach(doc => {
        if (doc.mainDepartmentId == mainDep) {
          var node = new TreeNode(doc.name);
          Tnode.addChild(node);
          this.addChildDep(node, doc.id);
        }
      });
    },
    getChildDep(dep) {
      let DepartmentList = this.departments;
      return DepartmentList.filter(function(department) {
        return department.id == dep.mainDepartmentId;
      });
    },
    getMainFind(id) {
      let DepartmentList = this.departments;
      let department = DepartmentList.filter(function(department) {
        return department.id == id;
      });
    },
    getAccessGroupFromId(id) {
      let aList = this.accessGroups;
      let dep = aList.filter(function(accessGroups) {
        return accessGroups.id == id;
      });
      if (dep != "" && dep != null) {
        return dep[0];
      } else {
        return null;
      }
    },
    async checkListFromAccessGroup(id) {
      let accessGroup = this.getAccessGroupFromId(id);
      let aa = this.readers;
      await aa.forEach(dd => {
        dd.check = false;
      });
      accessGroup.selectedReaders.forEach(secilenReader => {
        this.readers.forEach(doc => {
          if (doc.readerId == secilenReader.id) {
            doc.check = true;
          }
        });
      });
    },
    async getCheckReaderList() {
      let aList = this.readers;
      this.employee.readers = [];
      await aList.forEach(doc => {
        if (doc.check == true) {
          this.employee.readers.push(doc.readerId);
        }
      });
    },
    async setCheckReaderList() {
      let aa = this.readers;
      await aa.forEach(dd => {
        dd.check = false;
      });
      let aList = this.employee.readers;
      await aList.forEach(secilenReader => {
        this.readers.forEach(doc => {
          if (doc.readerId == secilenReader) {
            doc.check = true;
          }
        });
      });
    },
    async getEmployeesFromCardNoFast(data){
      if(data.length > 9 && $.isNumeric(data) == true){
        await this.filtersClear();
        this.filters.nameOrCardNumber = data;
        this.filters.isVisitor = true;
        await this.getEmployees();
        this.searchText = "";
      } else {
        await this.filtersClear();
        this.filters.nameOrCardNumber = data;
        this.filters.isVisitor = true;
        await this.getEmployees();
      }
    },
    async getVisitorCardGroups() {
      try {
        const cardGroups = [];
        const response = await this.$axios
          .get("/Visitors/GetVisitorsCardGroup")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                cardGroups.push({
                  id: doc.id,
                  name: doc.name,
                  devices: doc.devices
                });
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.visitorCardGroups = cardGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
      }
    },
    async getAccessGroups() {
      try {
        const accessGroups = [];
        const response = await this.$axios
          .get("/AccessGroups")
          .then(response => {
            response.data.forEach(doc => {
              accessGroups.push({
                id: doc.id,
                name: doc.name,
                isNewReaderAdd: doc.isNewReaderAdd,
                selectedReaders: doc.postReaders
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.accessGroups = accessGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getDepartments() {
      const departments = [];
      try {
        const response = await this.$axios
          .get("/Department")
          .then(response => {
            response.data.forEach(doc => {
              departments.push({
                id: doc.id,
                name: doc.name,
                mainDepartmentId: doc.mainDepartmentId,
                isActive: doc.isActive,
                locationTree: doc.locationTree,
                userId: doc.userId,
                check: false
              });
            });
            departments.sort((a, b) => {
              if (a.locationTree < b.locationTree) return -1;
              if (a.locationTree > b.locationTree) return 0;
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.setTree();
        this.departments = departments;
        this.sortableTrees();
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
      }
    },
    sortableTrees() {
      this.sortableDepTrees = [];
      this.departments.forEach(dep => {
        if (dep.mainDepartmentId == null) {
          this.sortableDepTrees.push(dep);
          this.subDepImport(dep);
        }
      });
    },
    subDepImport(dep) {
      let subDep = this.departments.filter(function(doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        let ek = subDep[0].locationTree.split("/");
        for (let index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(doc2 => {
          this.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          this.subDepImport(doc2);
        });
      }
    },
    async getFoodGroups() {
      try {
        const foodGroups = [];
        const response = await this.$axios
          .get("/FoodGroups")
          .then(response => {
            response.data.forEach(doc => {
              foodGroups.push({
                id: doc.id,
                name: doc.name,
                type: doc.type,
                singleFoodEachMeal: doc.singleFoodEachMeal,
                meals: doc.meals
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.foodGroups = foodGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStatus() {
      try {
        const status = [];
        const response = await this.$axios
          .get("/Employees/getStatus")
          .then(response => {
            response.data.forEach(doc => {
              status.push({
                id: doc.id,
                name: doc.name
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.status = status;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getInOuts() {
      if (this.isNewEmployee) {
        alertify.warning(this.$ml.get("alerts.selectedEmployeeNotBlank"));
        return;
      }
      if (
        this.inOut.inOutStartDate == null ||
        this.inOut.inOutEndDate == null ||
        this.inOut.inOutStartDate > this.inOut.inOutEndDate
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoadingInOuts = true;
        const inOuts = [];
        let selectedUser = this.employee.id;
        var startDate = this.inOut.inOutStartDate;
        var endDate = this.inOut.inOutEndDate;
        const response = await this.$axios
          .post("/EmployeeDetails/GetEntryExit", {
            id: selectedUser,
            startDate: startDate,
            endDate: endDate
          })
          .then(response => {
            response.data.forEach(doc => {
              inOuts.push({
                id: doc.id,
                date: doc.date,
                readerName: doc.readerName,
                readerId: doc.readerId,
                doorType: doc.doorType,
                inOrOut: doc.inOrOut,
                isActive: doc.isActive
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoadingInOuts = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoadingInOuts = false;
              return;
            }
          });
        this.employee.inOuts = inOuts;
        this.isLoadingInOuts = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingInOuts = false;
      }
    },
    async newEmployee() {
      this.isLoading = true;
      this.isNewEmployee = true;
      this.imageData = null;
      this.tempUrl = null;
      this.selectedFoodType = 1;
      this.selectedFoodCount = 0;
      this.isNewState = true;
      this.selectedStateId = null;
      this.selectedStateName = "";
      this.isNewStatu = true;
      this.selectedStatuId = null;
      this.selectedStatuName = "";
      this.searchPayrollStartDate = null;
      this.searchPayrollEndDate = null;
      this.selectAP = 1;
      this.employee.id = null;
      this.employee.sicilNo = "";
      this.employee.image = null;
      this.employee.name = "";
      this.employee.departmentId = null;
      this.employee.title = "";
      this.employee.identityNo = "";
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      this.employee.startDate = yil + "-" + ay + "-" + gun;
      this.employee.endDate = null;
      this.employee.stateId = 1;
      this.employee.stateNote = "";
      this.employee.terminalNo = null;
      this.employee.statuId = null;
      this.employee.cardNo = "";
      this.employee.terminalStatu = 0;
      this.employee.terminalPassword = "";
      this.employee.workGroupId = null;
      this.employee.documentNo = "";
      this.employee.salary = null;
      this.employee.overWorkStatus = true;
      this.employee.mail = "";
      this.employee.mobilePhone = "";
      this.employee.birthDayDate = null;
      this.employee.address = "";
      this.employee.internalPhone = "";
      this.employee.homePhone = "";
      this.employee.gender = null;
      this.employee.educationStatus = null;
      this.employee.militaryStatus = null;
      this.employee.drivingLicence = "";
      this.employee.smokeStatus = null;
      this.employee.maritalStatus = null;
      this.employee.bloodType = "";
      this.employee.height = null;
      this.employee.weight = null;
      this.employee.disabledPercent = "";
      this.employee.authorizedPerson1 = null;
      this.employee.authorizedPerson2 = null;
      this.employee.note1 = "";
      this.employee.note2 = "";
      this.employee.foreignLanguage = "";
      this.employee.accessGroupId = null;
      this.employee.readers = [];
      this.employee.foodGroupId = null;
      this.employee.credit = 0;
      this.employee.remainder = "0";
      this.employee.isVisitor = true;
      this.employee.visitorCardGroupId = null;
      this.employee.isActive = true;
      this.employee.annualPermitId = 0;
      this.employee.annualPermitSeniority = 0;
      this.employee.annualPermitTransfer = 0;
      this.employee.annualPermitClaim = 0;
      this.employee.annualPermitUsed = 0;
      this.employee.annualPermitRemain = 0;
      this.employee.annualPermits = [];
      this.employee.annualPermitClaimsDates = [];
      this.employee.extrafields = [];
      this.employee.inOuts = [];
      this.employee.allowences = [];
      this.employee.logs = [];
      this.employee.hasCard = false;
      this.employee.hasFace = false;
      this.employee.hasFinger = false;
      this.employee.hasPassword = false;
      await this.getNewSicilveTerminalNo();
      let aa = this.readers;
      await aa.forEach(dd => {
        dd.check = false;
      });
      this.isLoading = false;
    },
    async deleteEmployee() {
      try {
        this.isLoading = true;
        let id = this.employee.id;
        const response = await this.$axios.delete("/Employees/" + id);
        this.getEmployees();
        this.newEmployee();
        alertify.success(response.data.message);
        this.isLoading = false;
      } catch (error) {
        alertify.error(error);
        this.isLoading = false;
      }
    },
    async saveEmployee() {
      if (this.employee.sicilNo == "") {
        alertify.warning(
          this.$ml.get("alerts.visitorCardRegistrationNumberNotBlank")
        );
        return;
      }
      if (this.employee.name == "") {
        alertify.warning(this.$ml.get("alerts.visitorCardNameNotBlank"));
        return;
      }
      if (this.employee.terminalNo == "") {
        alertify.warning(this.$ml.get("alerts.visitorCardDeviceNoNotBlank"));
        return;
      }
      if (this.employee.startDate == "") {
        alertify.warning(this.$ml.get("alerts.visitorCardCreateDateNotBlank"));
        return;
      }
      this.isLoading = true;
      await this.getCheckReaderList();
      if (this.isNewEmployee) {
        try {
          let employee2 = this.employee;
          var id = 0;
          let image = this.imageData;
          const response = await this.$axios
            .post("/Employees", {
              sicilNo: employee2.sicilNo,
              name: employee2.name,
              departmentId: employee2.departmentId,
              title: employee2.title,
              identityNo: employee2.identityNo,
              startDate: employee2.startDate,
              endDate: employee2.endDate,
              stateId: employee2.stateId,
              stateNote: employee2.stateNote,
              terminalNo: employee2.terminalNo,
              statuId: employee2.statuId,
              cardNo: employee2.cardNo,
              terminalStatu: employee2.terminalStatu,
              terminalPassword: employee2.terminalPassword,
              workGroupId: employee2.workGroupId,
              documentNo: employee2.documentNo,
              salary: employee2.salary,
              overWorkStatus: employee2.overWorkStatus,
              mail: employee2.mail,
              address: employee2.address,
              mobilePhone: employee2.mobilePhone,
              birthDayDate: employee2.birthDayDate,
              internalPhone: employee2.internalPhone,
              homePhone: employee2.homePhone,
              gender: employee2.gender,
              educationStatus: employee2.educationStatus,
              militaryStatus: employee2.militaryStatus,
              drivingLicence: employee2.drivingLicence,
              smokeStatus: employee2.smokeStatus,
              maritalStatus: employee2.maritalStatus,
              bloodType: employee2.bloodType,
              height: employee2.height,
              weight: employee2.weight,
              disabledPercent: employee2.disabledPercent,
              authorizedPerson1: employee2.authorizedPerson1,
              authorizedPerson2: employee2.authorizedPerson2,
              note1: employee2.note1,
              note2: employee2.note2,
              foreignLanguage: employee2.foreignLanguage,
              accessGroupId: parseInt(employee2.accessGroupId),
              readers: employee2.readers,
              foodGroupId: employee2.foodGroupId,
              credit: employee2.credit,
              remainder: employee2.remainder,
              isVisitor: employee2.isVisitor,
              visitorCardGroupId: employee2.visitorCardGroupId,
              annualPermitId: employee2.annualPermitId,
              annualPermitSeniority: employee2.annualPermitSeniority,
              annualPermitTransfer: employee2.annualPermitTransfer,
              validityDate: employee2.validityDate,
              parentPhone: employee2.parentPhone,
              isSmsSend: employee2.isSmsSend,
              isStudent: employee2.isStudent,
              isStayInDormitory: employee2.isStayInDormitory,
              motherName: employee2.motherName,
              motherPhone: employee2.motherPhone,
              fatherName: employee2.fatherName,
              fatherPhone: employee2.fatherPhone,
              isMobileUser: employee2.isMobileUser,
              mobilePassword: employee2.mobilePassword
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              }
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingInOuts = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingInOuts = false;
                return;
              }
            });
          id = response.data.id;
          if (id != 0) {
            if (this.imageData) {
              const formData = new FormData();
              formData.append("file", image);
              if (this.imageData != null) {
                const responseImage = await this.$axios.post(
                  "/Employees/AddEmployeePhoto/" + id,
                  formData
                );
              }
            }
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
            this.getEmployees();
            this.getEmployee(id);
            this.isNewEmployee = false;
            this.isLoading = false;
          } else {
            alertify.error(response.message);
            this.isLoading = false;
          }
        } catch (error) {
          this.isLoading = false;
          console.error(error);
          alertify.error(error);
        }
      } else {
        //GÜNCELLE
        try {
          let employee2 = this.employee;
          let id = employee2.id;
          let image = this.imageData;
          const response = await this.$axios
            .post("/Employees/" + employee2.id, {
              sicilNo: employee2.sicilNo,
              name: employee2.name,
              departmentId: employee2.departmentId,
              title: employee2.title,
              identityNo: employee2.identityNo,
              startDate: employee2.startDate,
              endDate: employee2.endDate,
              stateId: employee2.stateId,
              stateNote: employee2.stateNote,
              terminalNo: employee2.terminalNo,
              statuId: employee2.statuId,
              cardNo: employee2.cardNo,
              terminalStatu: employee2.terminalStatu,
              terminalPassword: employee2.terminalPassword,
              workGroupId: employee2.workGroupId,
              documentNo: employee2.documentNo,
              salary: employee2.salary,
              overWorkStatus: employee2.overWorkStatus,
              mail: employee2.mail,
              address: employee2.address,
              mobilePhone: employee2.mobilePhone,
              birthDayDate: employee2.birthDayDate,
              internalPhone: employee2.internalPhone,
              homePhone: employee2.homePhone,
              gender: employee2.gender,
              educationStatus: employee2.educationStatus,
              militaryStatus: employee2.militaryStatus,
              drivingLicence: employee2.drivingLicence,
              smokeStatus: employee2.smokeStatus,
              maritalStatus: employee2.maritalStatus,
              bloodType: employee2.bloodType,
              height: employee2.height,
              weight: employee2.weight,
              disabledPercent: employee2.disabledPercent,
              authorizedPerson1: employee2.authorizedPerson1,
              authorizedPerson2: employee2.authorizedPerson2,
              note1: employee2.note1,
              note2: employee2.note2,
              foreignLanguage: employee2.foreignLanguage,
              accessGroupId: parseInt(employee2.accessGroupId),
              readers: employee2.readers,
              foodGroupId: employee2.foodGroupId,
              credit: employee2.credit,
              remainder: employee2.remainder,
              isVisitor: employee2.isVisitor,
              visitorCardGroupId: employee2.visitorCardGroupId,
              annualPermitId: employee2.annualPermitId,
              annualPermitSeniority: employee2.annualPermitSeniority,
              annualPermitTransfer: employee2.annualPermitTransfer,
              validityDate: employee2.validityDate,
              parentPhone: employee2.parentPhone,
              isSmsSend: employee2.isSmsSend,
              isStudent: employee2.isStudent,
              isStayInDormitory: employee2.isStayInDormitory,
              motherName: employee2.motherName,
              motherPhone: employee2.motherPhone,
              fatherName: employee2.fatherName,
              fatherPhone: employee2.fatherPhone,
              isMobileUser: employee2.isMobileUser,
              mobilePassword: employee2.mobilePassword
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                  return;
                } else if (error.response.status == 400) {
                  console.log(error.response.data.message);
                  alertify.error(error.response.data.message);
                  return;
                }
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          if (id != null) {
            if (this.imageData) {
              const formData = new FormData();
              formData.append("file", image);
              const responseImage = await this.$axios.post(
                "/Employees/AddEmployeePhoto/" + id,
                formData
              );
            } else if (this.employee.image == null) {
              const responseImage = await this.$axios.patch(
                "/Employees/RemovePhoto/" + id
              );
            }
            alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            this.getEmployees();
          } else {
            alertify.error(response.message);
          }
        } catch (error) {
          console.error(error);
          alertify.error(error);
        }
      }
      this.isLoading = false;
    },
    async getNewSicilveTerminalNo() {
      const response = await this.$axios
        .get("/Employees/GetDeviceAndSicilNumbers")
        .then(response => {
          this.employee.sicilNo = response.data.sicilNo;
          this.employee.terminalNo = response.data.terminalNo;
        })
        .catch(doc => {
          if (doc.status == 401) {
            this.$store.dispatch("logout");
          } else if (doc.message == "Network Error") {
            alertify.error(this.$ml.get("errors.connectionError"));
          } else {
            alertify.error(doc.message);
          }
        });
    },
    getDefaultDate() {
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.inOut.inOutStartDate == null) {
        this.inOut.inOutStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.inOut.inOutEndDate == null) {
        this.inOut.inOutEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.logStartDate == null) {
        this.logStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.logEndDate == null) {
        this.logEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    async getEmployee(id) {
      try {
        this.getDefaultDate();
        this.isLoading = true;
        this.tempUrl = null;
        this.imageData = null;
        const response = await this.$axios
          .get("/Employees/" + id)
          .then(response => {
            this.isNewEmployee = false;
            this.employee.id = id;
            this.employee.sicilNo = response.data.sicilNo;
            this.employee.image = response.data.image;
            this.employee.name = response.data.name;
            this.employee.departmentId = response.data.departmentId;
            this.employee.title = response.data.title;
            this.employee.identityNo = response.data.identityNo;
            this.employee.startDate = this.toDateFormat(
              response.data.startDate,
              "gg.aa.yyyy"
            );
            this.employee.endDate = response.data.endDate
              ? this.toDateFormat(response.data.endDate, "gg.aa.yyyy")
              : null;
            this.employee.stateId = response.data.stateId;
            this.employee.stateNote = response.data.stateNote;
            this.employee.terminalNo = response.data.terminalNo;
            this.employee.statuId = response.data.statuId;
            this.employee.cardNo = response.data.cardNo;
            this.employee.terminalStatu = response.data.terminalStatu;
            this.employee.terminalPassword = response.data.terminalPassword;
            this.employee.workGroupId = response.data.workGroupId;
            this.employee.documentNo = response.data.documentNo;
            this.employee.salary = response.data.salary;
            this.employee.overWorkStatus = response.data.overWorkStatus;
            this.employee.mail = response.data.mail;
            this.employee.mobilePhone = response.data.mobilePhone;
            this.employee.birthDayDate = response.data.birthDayDate
              ? this.toDateFormat(response.data.birthDayDate, "gg.aa.yyyy")
              : null;
            this.employee.address = response.data.address;
            this.employee.internalPhone = response.data.internalPhone;
            this.employee.homePhone = response.data.homePhone;
            this.employee.gender = response.data.gender;
            this.employee.educationStatus = response.data.educationStatus;
            this.employee.militaryStatus = response.data.militaryStatus;
            this.employee.drivingLicence = response.data.drivingLicence;
            this.employee.smokeStatus = response.data.smokeStatus;
            this.employee.maritalStatus = response.data.maritalStatus;
            this.employee.bloodType = response.data.bloodType;
            this.employee.height = response.data.height;
            this.employee.weight = response.data.weight;
            this.employee.disabledPercent = response.data.disabledPercent;
            this.employee.authorizedPerson1 = response.data.authorizedPerson1;
            this.employee.authorizedPerson2 = response.data.authorizedPerson2;
            this.employee.note1 = response.data.note1;
            this.employee.note2 = response.data.note2;
            this.employee.foreignLanguage = response.data.foreignLanguage;
            this.employee.accessGroupId = response.data.accessGroupId;
            this.employee.readers = response.data.readers;
            this.employee.foodGroupId = response.data.foodGroupId;
            this.employee.credit = response.data.credit;
            this.employee.remainder = response.data.remainder;
            this.employee.isVisitor = response.data.isVisitor;
            this.employee.visitorCardGroupId = response.data.visitorCardGroupId;
            this.employee.isActive = response.data.isActive;
            this.employee.inOuts = [];
            this.employee.allowences = [];
            this.employee.logs = [];
            this.employee.extrafields = [];
            this.employee.empPayrolls = [];
            this.employee.annualPermitId = response.data.annualPermitId;
            this.employee.annualPermitClaim = response.data.annualPermitClaim;
            this.employee.annualPermitUsed = response.data.annualPermitUsed;
            this.employee.annualPermitRemain = response.data.annualPermitRemain;
            this.employee.annualPermits = response.data.annualPermits;
            this.employee.annualPermitClaimsDates =
              response.data.annualPermitClaimsDates;
            this.employee.annualPermitSeniority =
              response.data.annualPermitSeniority;
            this.employee.annualPermitTransfer =
              response.data.annualPermitTransfer;
            this.employee.hasCard = response.data.hasCard;
            this.employee.hasFace = response.data.hasFace;
            this.employee.hasFinger = response.data.hasFinger;
            this.employee.hasPassword = response.data.hasPassword;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        await this.setCheckReaderList();
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoading = false;
      }
    },
    async changeFilterDep(dep, checkValue) {
      dep.check = checkValue;
      this.sortableDepartmentList.forEach(doc => {
        if (doc.mainDepartmentId == dep.id) {
          doc.check = checkValue;
          this.changeFilterDep(doc, checkValue);
        }
      });
    },
    async getCheckDepartmentAll(value) {
      this.sortableDepartmentList.forEach(dep => {
        dep.check = value;
      });
      this.isCheckDeps = !this.isCheckDeps;
    },
    async getCheckDepartmentList() {
      let aList = this.sortableDepartmentList;
      this.filters.departments = [];
      await aList.forEach(doc => {
        if (doc.check == true) {
          this.filters.departments.push(doc.id);
        }
      });
    },
    async getEmployees() {
      try {
        this.isLoadingEmployee = true;
        await this.getCheckDepartmentList();
        const employees = [];
        let filters2 = this.filters;
        const response = await this.$axios
          .post("/Employees/getByFilter", {
            nameOrCardNumber: filters2.nameOrCardNumber,
            sicilOrTerminalNo: filters2.sicilOrTerminalNo,
            departments: filters2.departments,
            accessGroup: filters2.accessGroup,
            identityNo: filters2.identityNo,
            documentNoOrMail: filters2.documentNoOrMail,
            foodGroup: filters2.foodGroup,
            workGroupId: filters2.workGroupId,
            title: filters2.title,
            stateId: filters2.stateId,
            statuId: filters2.statuId,
            plateNo: filters2.plateNo,
            extraField1key: filters2.extraField1key,
            extraField1value: filters2.extraField1value,
            extraField2key: filters2.extraField2key,
            extraField2value: filters2.extraField2value,
            extraField3key: filters2.extraField3key,
            extraField3value: filters2.extraField3value,
            extraField4key: filters2.extraField4key,
            extraField4value: filters2.extraField4value,
            isVisitor: filters2.isVisitor,
            isActive: filters2.isActive
          })
          .then(response => {
            response.data.forEach(doc => {
              employees.push({
                id: doc.id,
                name: doc.name,
                sicilNo: doc.sicilNo,
                title: doc.title
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              } else if (error.response.status == 403) {
                alertify.message(
                  this.$ml.get("alerts.userIsNotAuthorizedToSeeData")
                );
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingEmployee = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingEmployee = false;
                return;
              }
            }
          });
        this.employees = employees;
        this.isLoadingEmployee = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingEmployee = false;
      }
    },
    async getAllEmployees() {
      try {
        const allEmployees = [];
        const response = await this.$axios
          .get("/Employees")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                allEmployees.push({
                  id: doc.id,
                  name: doc.name,
                  title: doc.title,
                  isVisitor: doc.isVisitor
                });
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.allEmployees = allEmployees;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage")
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getDefaultDate();
    await this.getAllEmployees();
    await this.getReaders();
    await this.getDepartments();
    await this.getAccessGroups();
    await this.getStatus();
    await this.getVisitorCardGroups();
    await this.getEmployees();
    //await this.getFoodGroups();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/visitorCards/VisitorCards.vue